module.exports = __webpack_public_path__ + "img/jewellery.434dba3.webp";